import { createReducer, on } from '@ngrx/store';
import * as AuthActions from './auth.actions';
import { SerializableUser } from './auth.models';

export interface AuthState {
  currentUser: SerializableUser | null;
  loading: boolean;
  error: string | null;
}

export const initialState: AuthState = {
  currentUser: null,
  loading: false,
  error: null,
};

export const authReducer = createReducer(
  initialState,
  on(AuthActions.setCurrentUser, (state, { user }) => ({
    ...state,
    currentUser: user,
    loading: false,
    error: null,
  })),
  on(AuthActions.signInSuccess, (state, { user }) => ({
    ...state,
    currentUser: user,
    loading: false,
    error: null,
  })),
  on(AuthActions.signOut, (state) => ({
    ...state,
    loading: true,
  })),
  on(AuthActions.signOutSuccess, (state) => ({
    ...state,
    currentUser: null,
    loading: false,
    error: null,
  })),
  on(AuthActions.signOutFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  }))
);
